
import utilsModel from "../../../../engines/libs/utilsModel";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { GeneralKind } from "../../../define/GeneralKind";
import { MatchMiaiKind } from "../../../define/MatchMiaiKind";
import NormalGameManager from "../../manager/NormalGameManager";
import MatchMiaiData from "./MatchMiaiData";

export default class MatchMiaiDataManage {

    matchMiaiData = new MatchMiaiData();
 
    loadLocationData() {
        this.matchMiaiData.loadLocalData();
        this.initData();
    }

    saveAllLocationData() {
        this.matchMiaiData.saveLocalData();
    }

    initData() {
        if (!utilsModel.isValidNumberValue(this.matchMiaiData.curUseEquip)) {
            let csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.MATCH_MIAI);
            let title = csvInfos.title;
            for (let i in csvInfos) {
                if (i == 'title' || i == '' || i.trim() == '') {
                    continue;
                }
                let info = csvInfos[i];
                if (info[title.default_own] == GeneralKind.EnableState.ENABLED) {
                    this.matchMiaiData.curUseEquip = i;
                    this.matchMiaiData.ownEquipList.push(i);
                }
            }
            this.matchMiaiData.saveLocalData();
        }
        
    }

     /**
     * 每天数据处理
     */
    dayDataDispose() {
        if (this.matchMiaiData.bOpenBridePriceDTime) {
            let curDay = NormalGameManager._instance.getCurrentDay();
            let startTime = this.matchMiaiData.bridePrriceStartTime;
            if (curDay >= (startTime + MatchMiaiKind.GeneralValue.BRIDE_PRICE_DOWNTIME)) {
                // 结束倒计时
                this.matchMiaiData.bridePrriceStartTime = 0;
                this.matchMiaiData.bOpenBridePriceDTime = false;
                this.resetLevelData();
                this.matchMiaiData.saveLocalData();
            }
        }
    }

    resetLevelData() {
        this.matchMiaiData.curUseEquip = this.matchMiaiData.ownEquipList[0];
        this.matchMiaiData.bEndGame = false;
        this.matchMiaiData.bEndSecond = false;
        this.matchMiaiData.adEquipCount = [];
        let len = this.matchMiaiData.ownEquipList.length;
        for (let m = len-1; m >= 0; m--) {
            if (m==0) {
                continue;
            }
            if (this.matchMiaiData.ownEquipList[m] != MatchMiaiKind.GeneralValue.CUPID_ARROW_ID) {
                this.matchMiaiData.ownEquipList.splice(m, 1);
            }
        }

    }

    /** 添加丘比特神箭 */
    addCupidArrow() {
        let goodsId = MatchMiaiKind.GeneralValue.CUPID_ARROW_ID;
        let matchMiaiData = this.matchMiaiData;
        if (!matchMiaiData.ownEquipList.includes(goodsId)) {
            matchMiaiData.ownEquipList.push(goodsId);
            matchMiaiData.saveLocalData();
        }
    }

}
